/*eslint no-undef: "off"*/

import { useMutation } from '@tanstack/vue-query'

// Soft-deletes one recipient row (`id`), or every row scoped to `resourceId` (all when omitted).
export function useQueryNotificationUserDelete() {
    const { featureFlags } = useAnalytics()

    async function destroy({ id = null, resourceId = null } = {}) {
        const { dashboardAPI } = useAPI()

        if (id) return dashboardAPI(`/notifications/user/${id}`, { method: 'DELETE' })

        const query = resourceId ? `?${new URLSearchParams({ resource_id: resourceId })}` : ''

        return dashboardAPI(`/notifications/user${query}`, { method: 'DELETE' })
    }

    return useMutation({
        // No-ops while the notifications flag is off so nothing reaches the API.
        mutationFn: (scope) => (featureFlags.signalWatchNotifications ? destroy(scope) : null),
    })
}
